import { c as _c } from "react/compiler-runtime";
import { useId, type ChangeEvent } from "react";
import type { Suggestion } from "../types";
import { getSuggestionOptionLabel } from "../utils/formatting";
interface NftSuggestNativeSelectProps {
  readonly items: Suggestion[];
  readonly onSelect: (item: Suggestion) => void;
}
const ACCESSIBLE_SELECT_PLACEHOLDER_VALUE = "__nft_suggest_placeholder__";
const ACCESSIBLE_SELECT_MAX_SIZE = 10;
type SuggestionOptionValue = typeof ACCESSIBLE_SELECT_PLACEHOLDER_VALUE | Suggestion["address"];
const isSuggestionAddress = (value: SuggestionOptionValue): value is Suggestion["address"] => value !== ACCESSIBLE_SELECT_PLACEHOLDER_VALUE;
export function NftSuggestHiddenSelect(t0) {
  const $ = _c(18);
  const {
    items,
    onSelect
  } = t0;
  const nativeSelectDescriptionId = useId();
  const nativeSelectSize = Math.min(Math.max(items.length || 0, 1), ACCESSIBLE_SELECT_MAX_SIZE);
  const hasSuggestions = items.length > 0;
  let t1;
  if ($[0] !== items || $[1] !== onSelect) {
    t1 = event => {
      const selectedValue = event.target.value as SuggestionOptionValue;
      if (!isSuggestionAddress(selectedValue)) {
        return;
      }
      const selectedSuggestion = items.find(item => item.address === selectedValue);
      if (selectedSuggestion) {
        onSelect(selectedSuggestion);
      }
    };
    $[0] = items;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNativeSelectChange = t1;
  let t2;
  if ($[3] !== nativeSelectDescriptionId) {
    t2 = <p id={nativeSelectDescriptionId} className="tw-sr-only">Choose an NFT collection from the following suggestions.</p>;
    $[3] = nativeSelectDescriptionId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = hasSuggestions ? "Select a suggestion" : "No suggestions available";
  let t4;
  if ($[5] !== t3) {
    t4 = <option value={ACCESSIBLE_SELECT_PLACEHOLDER_VALUE} disabled={true}>{t3}</option>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== items) {
    t5 = items.map(_temp);
    $[7] = items;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleNativeSelectChange || $[10] !== nativeSelectDescriptionId || $[11] !== nativeSelectSize || $[12] !== t4 || $[13] !== t5) {
    t6 = <select id="nft-picker-suggest-list" aria-label="NFT collections suggestions" aria-describedby={nativeSelectDescriptionId} className="tw-sr-only" size={nativeSelectSize} defaultValue={ACCESSIBLE_SELECT_PLACEHOLDER_VALUE} onChange={handleNativeSelectChange}>{t4}{t5}</select>;
    $[9] = handleNativeSelectChange;
    $[10] = nativeSelectDescriptionId;
    $[11] = nativeSelectSize;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t6) {
    t7 = <>{t2}{t6}</>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(suggestion) {
  return <option key={suggestion.address} value={suggestion.address} disabled={suggestion.tokenType !== "ERC721"}>{getSuggestionOptionLabel(suggestion)}</option>;
}